export const PLANS_ID = {
  SIMONLY: 'sim-only',
  FULL: 'full',
  FLOW: 'flow',
} as const;

export const PLANS_LABELS = {
  [PLANS_ID.SIMONLY]: 'Sim only',
  [PLANS_ID.FULL]: 'Full',
  [PLANS_ID.FLOW]: 'Flow',
} as const;

export type PartnerPlanId = typeof PLANS_ID[keyof typeof PLANS_ID];
export type PartnerPlanLabel = typeof PLANS_LABELS[keyof typeof PLANS_LABELS];

export const getPlanLabel = (partnerPlanId: PartnerPlanId | null | undefined): PartnerPlanLabel | '-' => {
  if (!partnerPlanId) return '-';
  return PLANS_LABELS[partnerPlanId] || '-';
};
